// extracted by mini-css-extract-plugin
export default {"root":"ErrorPage_root__0fMex"};